import Navbar from "../components/Navbar/Navbar";
import DashboardContainer from "../components/DashboardContainer/DashboardContainer";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const NewsFeed = ({ setThemeMode, themeMode }) => {
  const params = useParams();
  const [pathName, setPathName] = useState("");
  const [searchedText, setSearchedText] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    let pn = window.location.pathname.slice(1);
    const arr = pn.split("/");
    setPathName(arr[0]);
    console.log("pathname", arr[0]);
  }, [window.location.pathname]);
  return (
    <>
      <Navbar
        setSearchedText={setSearchedText}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        setThemeMode={setThemeMode}
        themeMode={themeMode}
      />
      <DashboardContainer
        type={pathName}
        searchedText={searchedText}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        setThemeMode={setThemeMode}
        themeMode={themeMode}
      />
    </>
  );
};

export default NewsFeed;
